import React from 'react'
import styled from 'styled-components'

import Title from '../components/Title'

const PageNotFound = props =>
  <div>
    <Title>Page Not Found</Title>
  </div>

export default styled(PageNotFound)`

`